import React from 'react'
import {graphql, StaticQuery} from "gatsby"
import {ThemeProvider} from 'styled-components';
import theme from '../utils/theme';
import StyledLayout from './StyledLayout';
import {createGlobalStyle} from 'styled-components';
import Nav from './navbar/nav/Navbar';
import Footer from './footer';

const GlobalStyle = createGlobalStyle`
    body {
        padding: 0;
        margin: 0; 
    }
    *, *::before, *::after {
        box-sizing: border-box;
    }
`;

const TemplateWrapper = ({children}) => (
    <ThemeProvider theme={theme}>
        <GlobalStyle/>
        {/*<Seo/>*/}
        <StaticQuery query={graphql`
        query SiteTitleQuery {
            site {
              siteMetadata {
                title
                menuLinks {
                name
                link
                }
              }
            }
        }
      `} render={data => (
            <div>
                <Nav links={data.site.siteMetadata.menuLinks}/>
                <StyledLayout>{children}</StyledLayout>
                <Footer/>
            </div>
        )}/>
    </ThemeProvider>
);
export default TemplateWrapper
